import CheckboxBinder from './binders/CheckboxBinder';
import RadioBinder from './binders/RadioBinder';
import SelectBinder from './binders/SelectBinder';
import MultiCheckboxBinder from './binders/MultiCheckboxBinder';
import InputTextBinder from './binders/InputTextBinder';
import MultiSelectBinder from './binders/MultiSelectBinder';
import FileBinder from './binders/FileBinder';

export default class PriceBinderFactory {
	constructor(calculatorFactory, summaryDisplayer, priceFormatter) {
		this.calculatorFactory = calculatorFactory;
		this.summaryDisplayer = summaryDisplayer;
		this.priceFormatter = priceFormatter;
	}

	createBinder(
		fieldType,
		fieldId,
		title,
		priceType,
		priceValue,
		calculationType,
		options = {}
	) {
		const calculator = this.calculatorFactory.create(
			priceType,
			priceValue,
			calculationType
		);

		switch (fieldType) {
			case 'text':
			case 'textarea':
			case 'email':
			case 'number':
			case 'url':
			case 'color':
			case 'fpfdate':
			case 'time':
				return new InputTextBinder(
					fieldId,
					title,
					calculator,
					this.summaryDisplayer,
					this.priceFormatter
				);

			case 'radio':
			case 'radio-colors':
			case 'radio-images':
				return new RadioBinder(
					fieldId,
					title,
					calculator,
					this.summaryDisplayer,
					this.priceFormatter,
					options?.optionLabel,
					options?.optionValue
				);

			case 'checkbox':
				return new CheckboxBinder(
					fieldId,
					title,
					calculator,
					this.summaryDisplayer,
					this.priceFormatter
				);

			case 'select':
				return new SelectBinder(
					fieldId,
					title,
					calculator,
					this.summaryDisplayer,
					this.priceFormatter,
					options?.optionLabel,
					options?.optionValue
				);

			case 'multiselect':
				return new MultiSelectBinder(
					fieldId,
					title,
					calculator,
					this.summaryDisplayer,
					this.priceFormatter,
					options?.optionLabel,
					options?.optionValue
				);

			case 'multi-checkbox':
				return new MultiCheckboxBinder(
					fieldId,
					title,
					calculator,
					this.summaryDisplayer,
					this.priceFormatter,
					options?.optionLabel,
					options?.optionValue
				);
			case 'file':
				return new FileBinder(
					fieldId,
					title,
					calculator,
					this.summaryDisplayer,
					this.priceFormatter
				);

			default:
				throw new Error(`Unsupported field type: ${fieldType}`);
		}
	}
}
